// Setup yup message
import { format } from 'date-fns';
import * as Yup from 'yup';
import { SHORT_ITALIAN_FORMAT } from '../../constants/dateFormats';
import { isEmpty } from '../../helpers/String';

export default function () {
  // eslint-disable-next-line func-names
  Yup.addMethod(Yup.object, 'atLeastOneOf', function (list) {
    return this.test({
      name: 'atLeastOneOf',
      message: 'Compilare almeno un campo',
      exclusive: true,
      params: { keys: list },
      test: (value) => value == null || list.some((f) => value[f] != null || !isEmpty(value[f])),
    });
  });

  // eslint-disable-next-line func-names
  Yup.addMethod(Yup.object, 'atLeastOneTrue', function (list) {
    return this.test({
      name: 'atLeastOneTrue',
      message: 'Per almeno uno dei campi deve essere selezionato Sì',
      exclusive: true,
      params: { keys: list },
      test: (value) => list.some((f) => !!value?.[f]),
    });
  });

  // eslint-disable-next-line func-names
  Yup.addMethod(Yup.string, 'sdo', function (data, message) {
    const { motherSdo } = data || {};
    const msg = `Le prime due cifre della SDO devono fare riferimento all'anno corrente o all'anno precedente`;

    return this.test('sdo', 'La SDO deve essere composta solo da numeri', (val) => {
      if (!val || /^[0-9]+$/.test(val?.trim())) return true;

      return false;
    })
      .test('sdo', message || msg, (value) => {
        if (!value || value.length <= 1) return true;

        const sdoSubString = value.substring(0, 2);

        // Block 2020s SDO
        if (sdoSubString === '20') return false;

        const currentYear = new Date().getFullYear().toString().substring(2, 4);
        const previousYear = (+currentYear - 1).toString();
        return sdoSubString === currentYear || sdoSubString === previousYear;
      })
      .test(
        'sdo',
        'La SDO del neonato deve essere diversa dalla SDO della madre',
        (value) => !(motherSdo && value && `${motherSdo}` === `${value}`)
      );
  });

  // eslint-disable-next-line func-names
  Yup.addMethod(Yup.date, 'sameDate', function (fixedDate, message) {
    return this.test(
      'sameDate',
      message,
      (value) =>
        value && format(value, SHORT_ITALIAN_FORMAT) === format(fixedDate, SHORT_ITALIAN_FORMAT)
    );
  });

  Yup.setLocale({
    mixed: {
      required: 'Questo campo è obbligatorio',
    },
    string: {
      email: 'Indirizzo email non valido',
      // eslint-disable-next-line no-template-curly-in-string
      length: 'Questo campo deve contenere ${length} caratteri',
      // eslint-disable-next-line no-template-curly-in-string
      min: 'Questo campo deve contenere almeno ${min} caratteri',
      // eslint-disable-next-line no-template-curly-in-string
      max: 'Questo campo può contenere al massimo ${max} caratteri',
    },
    date: {
      max: 'La data non può essere settata nel futuro',
      min: 'La data inserita non è valida',
    },
    number: {
      max: 'Il valore inserito è al di sopra del massimo consentito',
      min: 'Il valore inserito è al di sotto del minimo consentito',
    },
  });
}
